export const transactionTransform = (transaction) => {
    const base = transaction.find(({ code }) => code === 'S1') // base
    const discount = transaction.find(({ code }) => code === 'S2') // discount
    const options = transaction.find(({ code }) => code === 'S3') // option
    const protections = transaction.find(({ code }) => code === 'S4') // protection
    const sellingPrice = transaction.find(({ code }) => code === 'T1') // total
    const tradeIn = transaction.find(({ code }) => code === 'S5') // tradeIn
    const taxes = transaction.find(({ code }) => code === 'S6') // tax
    const lien = transaction.find(({ code }) => code === 'S7') // lien
    const rebate = transaction.find(({ code }) => code === 'S10') // rebate
    const toPay = transaction.find(({ code }) => code === 'T2') // toPay

    return [
        { ...base, isCardLayout: true },
        discount,
        options,
        protections,
        sellingPrice,
        tradeIn,
        taxes,
        lien,
        rebate,
        { ...toPay, isLast: true },
    ]
}
